/** Shown when creator_mode requested automatic translations; keep in sync with backend TRANSLATION_REVIEW_MESSAGE. */
export const TRANSLATION_REVIEW_HINT_EN =
  "Automatic translations were requested. They are suggestions only. Please review and correct all language versions (ger, eng, ita, cze).";

const LEGACY_GERMAN_MARKERS = [
  "Es wurden automatische Übersetzungen",
  "Bitte prüfen und korrigieren Sie alle Sprachversionen",
  "automatisch erzeugten Übersetzungen",
];

/** Replace known legacy German API messages so the UI stays English even against older backends. */
export function normalizeTranslationReviewMessage(apiMessage: string | undefined | null): string {
  const m = (apiMessage ?? "").trim();
  if (!m) {
    return TRANSLATION_REVIEW_HINT_EN;
  }
  if (LEGACY_GERMAN_MARKERS.some((marker) => m.includes(marker))) {
    return TRANSLATION_REVIEW_HINT_EN;
  }
  return m;
}
